import { MODULE_DEFAULT, MODULE_GLOBAL } from '../support/constant';

export default {
  [MODULE_DEFAULT]: 0,
  [MODULE_GLOBAL]: 0,
};
